/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../apimodel.d.ts" />
/// <reference path="../app.common.directives.module.ts" />
/// <reference path="validatorbase.ts" />
/// <reference path="validateargs.ts" />
/// <reference path="../../services/globalsettingsservice.ts" />
/// <reference path="datevalidatorbase.ts" />

module App.Common.Directives {
	'use strict';

	export class MustBeBetweenDates extends Directives.DateValidatorBase {

		public static $inject = ['$filter', 'app.common.services.globalSettingsService'];

		constructor($filter: angular.IFilterService, globalSettings: Common.Services.GlobalSettingsService) {
			super($filter, globalSettings);
		}

		public name = 'must-be-between-dates-min';

		public canValidate = (args: Directives.ValidateArgs) => {
			return args.modelValue() &&
				args.parameterValue() &&
				(_.isDate(args.modelValue()) || _.isDate(new Date(args.modelValue()))) &&
				(_.isDate(args.parameterValue()) || _.isDate(new Date(args.parameterValue()))) &&
				(_.isDate(args.attributeValue('mustBeBetweenDatesMax')) ||
					_.isDate(new Date(args.attributeValue('mustBeBetweenDatesMax'))));
		};
		public isValid = (args: Directives.ValidateArgs) => {
			return args.modelValue() >= args.parameterValue() &&
				args.modelValue() <= args.attributeValue('mustBeBetweenDatesMax');
		};
		public getWatchExpressions = (args: Directives.ValidateArgs) => {
			return [
				args.attributes[this.nameCamelCase()],
				args.attributes['mustBeBetweenDatesMax'],
				args.attributes.ngModel
			];
		};
		public resolveMessage = (args: ValidateArgs): string => {
			var minDate = args.parameterValue();
			var maxDate = args.attributeValue('mustBeBetweenDatesMax');
			var label = args.attributes['mustBeBetweenDatesLabel'] ||
				`between ${this.$filter('date')(minDate, this.globalSettings.shortDateFormat)} and ${this
				.$filter('date')(maxDate, this.globalSettings.shortDateFormat)}`;
			return `This date must be ${label}`;
		};
	}

	factory.$inject = ['$filter', 'app.common.services.globalSettingsService'];

	function factory($filter: angular.IFilterService, globalSettings: Common.Services.GlobalSettingsService) {
		return new MustBeBetweenDates($filter, globalSettings);
	}

	angular
		.module('app.common.directives')
		.directive('mustBeBetweenDatesMin', factory);
}